import { render } from "./BaseIcon.vue?vue&type=template&id=69cb2f9a"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"
script.render = render

export default script